
import { Component, Inject, Optional, OnInit } from '@angular/core';
import {  MatDatepickerInputEvent, MatSnackBar,MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import * as moment from 'jalali-moment';
import { InvoiceService } from '../../../services/Acc_InvoiceService';
import { Txn_Invoice } from '../../../models/Txn_Invoice';
import { student_term_status } from '../../../models/student-status-term';
import { GL_MasterService } from '../../../services/Acc_GL_Master.service';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-edit-invoice-term-dialog',
  templateUrl: './edit-invoice-term-dialog.component.html',
  styleUrls: ['./edit-invoice-term-dialog.component.css']
})
export class EditInvoiceTermDialogComponent implements OnInit {
  inv_number: number;
  remarks: string;
  inv_Date: Date;
  expiryDate: Date;
  st_name: string;
  semester: number;
  year: string;
  season: string;

  this_inv: Txn_Invoice = {
    authStat :'',
    checkerID : '',
    clearBankRefNO:'',
    clearDate:null,
    clear_status:'',
    discount_amount:0,
    inv_amount:0,
    inv_no:0,
    issueDate:null,
    expiryDate: null,
    issue_remark:'',
    makerID:'',
    payable_amount:0,
    relatedAccount:'',
    semester:0,
    trn_ref_clear:'',
    trn_ref_issue:'',
    invoiceType:'',
    invoiceDesc: '',
    year: "",
    season: "",
    installmentNumber: 0,
    installmentNumbers: '',
    isRepeatSemester: false,
    userId: '',
    branchId: '',
    discountValue: 0,
    repeatSemesterSerie: 1,
    termId:0,
  }

  form: FormGroup;
  constructor(
    public dialogRef: MatDialogRef<EditInvoiceTermDialogComponent>,
    private InvoiceService: InvoiceService,
    private snackBar: MatSnackBar,
    private GL_MasterService: GL_MasterService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: Txn_Invoice //,
    //@Optional() @Inject(MAT_DIALOG_DATA) public dataName: string
  ) {

    this.form = new FormGroup({
      selectSemesterFormControl: new FormControl(),
      issueDateFormControl: new FormControl(),
      expiryFormControl: new FormControl(),
      remarkFormControl: new FormControl()
    });



    console.log(data);
     
    this.inv_number = data.inv_no;
    this.inv_Date = new Date(data.issueDate);
    this.expiryDate = new Date(data.expiryDate);
    console.log(`expiry date: ` + this.expiryDate);
    this.remarks = data.issue_remark;
    this.st_name = (data as any).gL_ChildDesc;
    this.semester = data.semester;
    this.year = data.year;
    this.season = data.season;
    this.selectedTermId = data.termId;
    this.this_inv = data;

     
    this.GL_MasterService.getStudentStatusTerm(data.relatedAccount).subscribe(result => {
       
      this.statusStudentTerm = result.json() as student_term_status[];
      if (this.statusStudentTerm.length > 0) {
        this.termSelected = this.statusStudentTerm.find(f => f.termId == this.selectedTermId);
        if (this.termSelected == null) {
          this.termSelected = this.statusStudentTerm[0];
        }
        this.setSemesterDetail(this.termSelected);
        this.form.controls['selectSemesterFormControl'].setValue(this.selectedTermId);
      }
    });
     
  }

  statusStudentTerm: student_term_status[] = []
  termSelected: student_term_status;
  selectedTermId: number = 0;
  invoiceTypeSelected: string = "";
  setSemesterDetail(termSelected: student_term_status) {
     
    this.invoiceTypeSelected = "Fee";
    this.this_inv.termId = termSelected.termId;
    this.this_inv.semester = termSelected.semester;
    this.this_inv.season = termSelected.season.toString();    
  }

  selectSemesterChange($event) {
     
    var value = $event.value;
    this.selectedTermId = value;
    this.termSelected = this.statusStudentTerm.find(f => f.termId == value);
    this.setSemesterDetail(this.termSelected);
  }

  ngOnInit() {
   
  }

  issueDateChanged(event: MatDatepickerInputEvent<moment.Moment>) {
    var _pdate = moment(event.value).format('jYYYY-jMM-jDD');
    var _date = moment.from(_pdate, 'fa').format('YYYY-MM-DD');
    this.inv_Date = new Date(_date);
    console.log(`issue date:` +this.inv_Date);
    //this.fromDate_DariDate = _pdate;
  }

  expiryDateChanged(event: MatDatepickerInputEvent<moment.Moment>) {
    var _pdate = moment(event.value).format('jYYYY-jMM-jDD');
    var _date = moment.from(_pdate, 'fa').format('YYYY-MM-DD');
    this.expiryDate = new Date(_date);
    console.log(`expiry date:` + this.expiryDate);
    //this.fromDate_DariDate = _pdate;
  }

  updateInvoice() {
    this.this_inv.issueDate = this.inv_Date;
    this.this_inv.issue_remark = this.remarks;
    this.this_inv.expiryDate = this.expiryDate;

    this.InvoiceService.updateInvoice(this.this_inv).subscribe(response => {
      if (response == 'Success') {
        this.openSnackBarInfo('آپدیت شد', '');
      }
      else {
        this.openSnackBarInfo('خطا در آپدیت', '');
      }
    });

    //this.dialogRef.close({ event: 'close', data: this.this_inv });
  }


  openSnackBarInfo(message: string, action: string) {
    let snackBarRef = this.snackBar.open(message, action, {
      duration: 2000,
    });
    snackBarRef.closeWithAction = function () {
      snackBarRef.dismiss();
    }
  }

  closeDialog() {
    this.dialogRef.close({ event: 'close', data: this.this_inv });
  }

}



// WEBPACK FOOTER //
// ./src/app/components/management/edit-invoice-term-dialog/edit-invoice-term-dialog.component.ts